import type { CalcKey } from '../locales/keys';

export interface DerivativePreset {
  id: string;
  labelKey: CalcKey;
  /** Expression in variable `x` — must be parseable by @learnforge/demo-math/expr. */
  source: string;
  domain: [number, number];
}

export const DERIVATIVE_PRESETS: DerivativePreset[] = [
  {
    id: 'cubic',
    labelKey: 'preset.derivative.cubic',
    // f(x) = x³ − 3x; f′(x) = 3x² − 3; critical points at x = ±1.
    source: 'x^3 - 3 * x',
    domain: [-3, 3],
  },
  {
    id: 'sine',
    labelKey: 'preset.derivative.sine',
    // f(x) = sin(x); f′(x) = cos(x); gentle wave, easy to visualise.
    source: 'sin(x)',
    domain: [-2 * Math.PI, 2 * Math.PI],
  },
  {
    id: 'parabola',
    labelKey: 'preset.derivative.parabola',
    // f(x) = x²; f′(x) = 2x; simplest non-trivial derivative.
    source: 'x^2',
    domain: [-4, 4],
  },
  {
    id: 'bell',
    labelKey: 'preset.derivative.bell',
    // f(x) = exp(−x²); bell curve; f′(x) = −2x · exp(−x²); nice sign-change at x=0.
    source: 'exp(-1 * x^2)',
    domain: [-3, 3],
  },
];
